<h1 mat-dialog-title>{{ "settings.new_app_version_dialog.title" | translate }}</h1>
<div mat-dialog-content>
	<p>
		{{ "settings.new_app_version_dialog.description" | translate }}
	</p>
	<p>{{ "settings.new_app_version_dialog.contact_system_admin" | translate }}</p>
</div>
<div align="end" mat-dialog-actions>
	<button class="close-button" data-test="close-button" [mat-dialog-close]="true">
		{{ "general.close" | translate }}
	</button>
</div>
